import Sidebar from '../../components/sidebar/Sidebar'
import Header from '../../components/headerbar/Header'
import './category.scss'
import {config} from '../../config'
import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
// import CategorySub from "../../SubCategory/SubCategory";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Divider from '@mui/material/Divider';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import axios from 'axios'
import { formatISODateToCustomFormat } from '../../utils'
import _ from 'lodash'

const Category = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [categories, setCategories] = useState([])
  const [editEnabled, setEditEnabled] = useState(false);
  const focusRef = useRef(null);
  const navigate = useNavigate()
  useEffect(() => {
    getCategory()
  }, [])

  const getCategory = async () => {
    let catresult = await fetch(config.apiurl + '/category/getcategory')
    catresult = await catresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    !catresult?.data?.results?.length && toast("No Data found...!", {
              type: "info",
              autoClose: 900,
            });
    setCategories(catresult?.data?.results)
  }

  const [name, setName] = useState('')
  const [updateid, setUpdateid] = useState('')
  const [error, setError] = useState(false)

  const [search, setSearch] = useState(""); 

  const handleCatsubmit = async () => {
    if (!name?.trim()) {
      setError(true)
      return false
    }
    let apicaturl = ''
    let methodapi = ''
    if (updateid) {
      apicaturl = config.apiurl + '/category/' + updateid
      methodapi = 'put'
    } else {
      apicaturl = config.apiurl + '/category/'
      methodapi = 'post'
    }

    let addcat = await fetch(apicaturl, {
      method: methodapi,
      body: JSON.stringify({ name }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }).catch((err) => toast(err.response.data.message, {type: "error"}))

    let addcatrs = await addcat.json().then((addcatrs) => {
      if (addcatrs.status === 'true') {
        toast(editEnabled ? 'Updated successfully' : "Added successfully")
        editEnabled && setEditEnabled(false)
        setUpdateid("") 
        setError(false)
        setName('')
        getCategory()
      }
      else{
        toast(addcatrs?.message || "Something Went Wrong", {type: "error"})
      }

    }).catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
  }

  const getCategoryedit = async (editid) => {
    let cateditdetails = await fetch(config.apiurl + '/category/' + editid, {
      method: 'get',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    cateditdetails = await cateditdetails.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    setName(cateditdetails.data[0].name)
    !_.isEmpty(cateditdetails) && setEditEnabled(true);
    setUpdateid(cateditdetails.data[0]._id)
  }

  const deleteCategory = async (id) => {
    let deletecat = await fetch(config.apiurl + '/category/' + id, {
      method: 'Delete',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    deletecat = await deletecat.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    if (deletecat) {
      getCategory()
    }
  }

  const handleReset = () => {
    setSearch("");
    getCategory();
  }

  const handleSearch = (e) => {
    e.preventDefault();
    axios
      .get(config.apiurl + "/category/getcategory", {
        params: { search: search?.trim() },
      })
      .then((res) => {
        if(res?.data?.data?.results?.length > 0) {
            setCategories(res?.data?.data?.results)
          } else {
            setCategories([]);
            toast("No Data found...!", {
              type: "info",
              autoClose: 900,
            })
          }
      })
      .catch((err) => {
        toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {
          type: "error",
        })
      }
      );
  }

  const handleFocus = () => {
    focusRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-md-8">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Category</h6>
                    </div>

                    {/* <div className="col-6 text-end">
                                    <a ahrefjavascript="javascript:void(0);" className="btn btn-outline-primary btn-sm mb-0 "  >Import</a> &nbsp;&nbsp;
                                    <a ahrefjavascript="/category/add" className="btn btn-outline-primary btn-sm mb-0 ">Add New</a>
                                </div> */}
                  </div>
                </div>
                <Paper
                  component="form"
                  onSubmit={handleSearch}
                  sx={{
                    p: "2px 4px",
                    m: "10px 10px 10px auto",
                    display: "flex",
                    alignItems: "end",
                    width: 250,
                  }}
                >
                  <InputBase
                    sx={{ ml: 1, flex: 1, height: "2.4375em" }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search", "spellcheck": "false" }}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    onClick={handleReset}
                    sx={{ p: "10px" }}
                    aria-label="reset"
                  >
                    <RestartAltIcon />
                  </IconButton>
                </Paper>
                <Divider variant="middle" />
                <div className="card-body px-0 pt-0 pb-2">
                  <div className="table-responsive p-5">
                    <table className="table align-items-center mb-0 ">
                      <thead>
                        <tr>
                          <th className="text-secondary opacity-7 ps-2">
                            S.No
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Name
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Created At
                          </th>
                          <th className="text-secondary opacity-7">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories &&
                          categories.map((item, index) => (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div className="d-flex flex-column justify-content-center">
                                    <h6 className="mb-0 text-sm">
                                      {item.name}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div className="d-flex flex-column justify-content-center">
                                    <h6 className="mb-0 text-sm">
                                      {formatISODateToCustomFormat?.(item?.createdAt) ?? "-"}
                                    </h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="ms-auto">
                                  <a
                                    className="btn btn-link text-primary px-3 mb-0"
                                    onClick={() => (getCategoryedit(item._id), handleFocus())}
                                  >
                                    <i
                                      className="fas fa-pencil-alt text-primary me-2"
                                      aria-hidden="true"
                                    ></i>
                                    Edit
                                  </a>
                                  {/* <a
                                    className="btn btn-link text-danger px-3 mb-0"
                                    onClick={() => deleteCategory(item._id)}
                                  >
                                    <i
                                      className="fa fa-trash text-dark me-2"
                                      aria-hidden="true"
                                    ></i>
                                    Delete
                                  </a> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4" ref={focusRef}>
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Add/Edit Category</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label
                          data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Name
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter Category Name"
                          required
                          value={name}
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                        />
                        {error && !name?.trim() && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            Enter the category name
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="text-end">
                      <button
                        type="button"
                        onClick={handleCatsubmit}
                        className="btn btn-primary btn-sm ms-auto mt-5"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  );
}

export default Category
